import Controller from 'controllers/controller';
import LazySvgController from 'controllers/components/lazy-svg';
import Elements from 'tools/elements';

class LazySvgsController extends Controller {
    ready() {
        this.controllerInstances = [ ];
        this.elements = new Elements;
        
        this.attachEvents();
        this.init();
    }

    attachEvents() {
        this.app.on('dom-change', this.init);
    }
    
    init() {
        this.cacheElements();
        this.initControllers();
    }
    
    cacheElements() {
        // Find all individual lazy SVGs
        this.elements.queryAll('svgs', '.lazy-svg:not(.loading)');
    }
    
    initControllers() {
        // Instaniate controllers for each lazy SVG
        this.elements.each('svgs', svg => {
            this.app.make(LazySvgController, svg);
        });
    }
}

export default LazySvgsController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/lazy-svgs.js